import { SettingsV1TenantType } from '@sdk/Api'
import { writable } from 'svelte/store'

export const tenantType = writable<SettingsV1TenantType>(SettingsV1TenantType.TENANT_TYPE_ECOMMERCE)
